import React, { useState, useEffect } from "react";
import { FaEdit, FaCheck, FaBan, FaAddressBook, FaBook, FaTrophy, FaUikit, FaDollarSign } from "react-icons/fa";
import { get, put } from "../../services/Services";
import "bootstrap/dist/css/bootstrap.min.css";
import EventEdit from "./EventEdit";
import Registrations from "../EventOrganization/Registrations";
import { Modal, Button } from "react-bootstrap";
import CoursesFormAdm from "../Courses/CoursesFormAdm";
import CoursesAdm from "../Courses/CoursesAdm";
import { useNavigate } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from "react-toastify";

import { jwtDecode } from "jwt-decode";

const EventsTable = ({events, setEvents, setShowFloatingButtons, refetch}) => {
  //const [events, setEvents] = useState([]);
  const [selectedEventId, setSelectedEventId] = useState(null);
  const [selectedEventConfigId, setSelectedEventConfigId] = useState(null);
  const [showEditForm, setShowEditForm] = useState(false);
  const [showRegistrations, setShowRegistrations] = useState(false);
  const [showCoursesAdm, setShowCoursesAdm] = useState(false);
  


  const handleToggleStatus = async (event) => {
    try {
      const response = await get(`/api/academy/events/${event.id}`);
      const updatedEvent = { ...response.data, status: !event.status };

      const updateResponse = await put(`/api/academy/events/${event.id}/status`, updatedEvent);
      toast.success("Estado modificado correctamente");
      if (!updateResponse) throw new Error("No se pudo actualizar el estado del evento.");

      setEvents((prevEvents) =>
        prevEvents.map((e) => (e.id === event.id ? { ...e, status: updatedEvent.status } : e))
      );
    } catch (error) {
      console.error("Error al cambiar el estado del evento:", error);
      alert(`Error al cambiar el estado del evento: ${error.message}`);
    }
  };

  const handleButtonClick = () => {
    setShowFloatingButtons(false); // Ocultar los botones flotantes al hacer clic en cualquier botón de la tabla
  };

  const handleEditClick = (eventId) => {
    setSelectedEventId(eventId);
    setShowEditForm(true);
  };
  const navigate = useNavigate(); // Hook para navegación
  
  const handleRegistrationsClick = async (eventId) => {
    try {
      const response = await get(`/api/academy/events/${eventId}`);
      const ConfigId = response.data.config?.id;
      const eventName = response.data.name;
      if (!ConfigId) {
        alert("No se encontró el eventConfigId para este evento.");
        return;
      }
      
      navigate("/eventorganization/registrations", {
        state: {eventId, ConfigId, eventName },
        
      });
    } catch (error) {
      console.error("Error al obtener eventConfigId:", error);
      alert("Error al obtener ConfigId.");
    }
  };
  
  const handleCoursesClick = async (eventId) => {
    try {
      const response = await get(`/api/academy/events/${eventId}`);
      const event = response.data;
  
      if (!event || !event.config?.id) {
        alert("No se encontró el configId para este evento.");
        return;
      }
  
      const ConfigId = event.config.id;
      const eventName = event.name;
      
      navigate("/courses/coursesadm", {
        state: { ConfigId, eventName, eventId },
      });
    } catch (error) {
      console.error("❌ Error al obtener eventConfigId:", error);
      alert("Error al obtener eventConfigId.");
    }
  };
  const handlePerformancesOrderClick = async (eventId) => {
    try {
      const response = await get(`/api/academy/events/${eventId}`);
      const event = response.data;
  
      if (!event || !event.config?.id) {
        alert("No se encontró el configId para este evento.");
        return;
      }
  
      const ConfigId = event.config.id;
      const eventName = event.name;
      navigate("/eventorganization/performancesorder", {
        state: { ConfigId, eventId, eventName },
      });
    } catch (error) {
      console.error("❌ Error al obtener eventConfigId:", error);
      alert("Error al obtener eventConfigId.");
    }
  };

  const handleAwardAllocationClick = async (eventId) => {
    try {
      const response = await get(`/api/academy/events/${eventId}`);
      const event = response.data;
  
      if (!event || !event.config?.id) {
        alert("No se encontró el configId para este evento.");
        return;
      }
  
      const ConfigId = event.config.id;
  
      navigate("/settingsaward/awardallocation", {
        state: { ConfigId, eventId },
      });
    } catch (error) {
      console.error("❌ Error al obtener eventConfigId:", error);
      alert("Error al obtener eventConfigId.");
    }
  };
  
  const handleFinancialMovementsClick = async (eventId) => {
    try {
      const response = await get(`/api/academy/events/${eventId}`);
      const event = response.data;
  
      if (!event || !event.config?.id) {
        alert("No se encontró el configId para este evento.");
        return;
      }
  
      const ConfigId = event.config.id;
  
      navigate("/payments/financialmovements", {
        state: { ConfigId },
      });
    } catch (error) {
      console.error("❌ Error al obtener eventConfigId:", error);
      alert("Error al obtener eventConfigId.");
    }
  };
  
  
  

  const handleCloseRegistrations = () => {
    setShowRegistrations(false);
    setSelectedEventId(null);  // Optional, to clear the selected event
  };

  return (
    <div className="container-fluid mt-4" aria-live="polite">
       {!showRegistrations && !showCoursesAdm && ( // Oculta la tabla si showCoursesAdm es true
      <div className="table-responsive">
         
       <table className="table table-striped table-hover table-bordered text-center w-100">
          <thead className="table-primary">
            <tr>
              <th>Nombre</th>
              <th>Fecha</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
  {Array.isArray(events) && events.length > 0 ? (
    events.map((event) => (
      <EventRow
        key={event.id}
        event={event}
        onToggleStatus={() => handleToggleStatus(event)}
        onEditClick={() => handleEditClick(event.id)}
        onRegistrationsClick={() => handleRegistrationsClick(event.id)}
        onCoursesClick={() => handleCoursesClick(event.id)}
        onPerformancesOrderClick={() => handlePerformancesOrderClick(event.id)}
        onAwardAllocationClick={() => handleAwardAllocationClick(event.id)}
        onFinancialMovementsClick={() => handleFinancialMovementsClick(event.id)}
      />
    ))
  ) : (
    <tr>
      <td colSpan="4" className="text-center">No hay eventos disponibles</td>
    </tr>
  )}
</tbody>

        </table>
      </div>
    )}

    

          {showCoursesAdm && selectedEventConfigId && ( // Renderiza CoursesAdm en lugar de la tabla
            <div className="mt-4">
              <CoursesAdm eventConfigId={selectedEventConfigId} setShowForm={() => setShowCoursesAdm(false)} refetch={refetch} />
            </div>
              )}

          {showEditForm && (
              <EventEdit eventId={selectedEventId} setShowForm={() => setShowEditForm(false)} refetch={refetch} />
            )}
          </div>
  );
};

const EventRow = ({ event, onToggleStatus, onEditClick, onRegistrationsClick, onCoursesClick, onPerformancesOrderClick, onAwardAllocationClick, onFinancialMovementsClick }) => {
   // Obtener token desde localStorage
  const token = localStorage.getItem("accessToken");

  // Decodificar y obtener username o sub
  let username = null;
  if (token) {
    try {
      const decoded = jwtDecode(token);
      username = decoded.username || decoded.sub || null;
    } catch (error) {
      console.error("Error decoding token:", error);
    }
  }

  console.log("Usuario desde token:", username);
  return (
    <tr>
      <td>{event.name || "Desconocido"}</td>
      <td>{event.eventDate || "No disponible"}</td>
      <td className={event.status ? "text-success fw-bold" : "text-danger fw-bold"}>
        {event.status ? "Habilitado" : "Deshabilitado"}
      </td>
      <td className="text-center">
        <button onClick={onToggleStatus} className={`btn ${event.status ? "btn-danger" : "btn-success"} btn-sm me-2`}>
          {event.status ? <FaBan /> : <FaCheck />}
        </button>
        <button onClick={onEditClick} className="btn btn-warning btn-sm me-2">
          <FaEdit /> Editar
        </button>
        <button onClick={onCoursesClick} className="btn btn-success btn-sm me-2">
          <FaBook /> Seminarios
        </button>
        <button onClick={onRegistrationsClick} className="btn btn-primary btn-sm me-2">
          <FaAddressBook /> Inscripciones
        </button>
        <button onClick={onPerformancesOrderClick} className="btn btn-dark btn-sm me-2">
          <FaUikit /> Orden de Obras
        </button>
        <button onClick={onAwardAllocationClick}  className="btn btn-danger btn-sm me-2">
          <FaTrophy /> Premiación
        </button>
        {username !== "operador" && (
          <button onClick={onFinancialMovementsClick} className="btn btn-success btn-sm me-2">
            <FaDollarSign /> Ingresos / Egresos
          </button>
        )}
      </td>
    </tr>
  );
};

export default EventsTable;
